class VariantDescription extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.contentEl = this.querySelector('[data-variant-description-content]');
    this.mapEl = this.querySelector('[data-variant-description-map]');
    if (!this.contentEl || !this.mapEl) return;

    let items = [];
    try { items = JSON.parse(this.mapEl.textContent || '[]'); } catch (e) {}
    this.byId = new Map(items.map(x => [String(x.id), x.html || ""]));

    this.form =
      this.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    this.render = this.render.bind(this);

    // Initial
    this.render();

    // Common events
    document.addEventListener('variant:change', this.render);

    // Generic “something changed in the form”
    if (this.form) {
      this.form.addEventListener('change', () => requestAnimationFrame(this.render));

      // Most reliable: watch the hidden variant id input if it exists
      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput) {
        const obs = new MutationObserver(this.render);
        obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });

        // Fallback for value changes not reflected as attribute updates
        let last = idInput.value;
        setInterval(() => {
          if (idInput.value !== last) { last = idInput.value; this.render(); }
        }, 250);
      }
    }
  }

  getVariantId() {
    if (!this.form) return null;
    const idInput = this.form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    const idSelect = this.form.querySelector('select[name="id"]');
    if (idSelect && idSelect.value) return String(idSelect.value);

    return null;
  }

  render() {
    const id = this.getVariantId();
    const html = id ? (this.byId.get(id) || "") : "";
    this.contentEl.innerHTML = html;
    this.style.display = html.trim() ? "" : "none";
  }
}

customElements.define('variant-description', VariantDescription);
